import { Exclude, plainToInstance, Type } from 'class-transformer'
import i18n from 'vue-i18n'

import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import DelaySampleNode from '../ui/SampleNode/DelaySampleNode.vue'
import DelayNodeSidebar from '../ui/Sidebar/DelayNodeSidebar.vue'
import {
  BaseDelayType,
  DelayDateType,
  DelayIntervalType,
  DelayPropertyType,
} from './DelayTypes'
import { DelayType } from './DelayTypes/types'
import ProxyDelayData from './Proxy/ProxyDelayData'
import { DelayNodeProps } from './types'

export default class DelayNodeBuilder extends CustomNodeComponent {
  sidebarComponent = DelayNodeSidebar

  constructor(i18n: i18n, nodeProps: DelayNodeProps) {
    super(DelaySampleNode, DelayNode, NodeTypes.Delay, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [ number, number ]) => {
    return {
      data: plainToInstance(DelayNodeData, {
        type: NodeTypes.Delay,
        delay: {
          type: DelayType.Interval,
          offset: 0,
        }
      }),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class DelayNode extends CustomNode {
  data: ProxyDelayData

  @Exclude()
  declare nodeProps: DelayNodeProps

  constructor(name: NodeTypes.Delay, model: BaseNodeModel, nodeProps: DelayNodeProps) {
    super(name, model, nodeProps)
    this.nodeProps = nodeProps

    if (model.data instanceof DelayNodeData) {
      this.data = new ProxyDelayData(model.data, nodeProps)
    } else {
      throw new Error('To node come unknown data')
    }
  }

  // // todo
  // getModel(): any {
  //   return {
  //     data: instanceToPlain(this.data),
  //     x: this.position[0],
  //     y: this.position[1],
  //     color: this.color,
  //
  //     ...this.mainInput ? { input: Number(this.mainInput) } : {},
  //     ...this.mainOutput ? { output: Number(this.mainOutput) } : {},
  //   }
  // }

}

export class DelayNodeData extends BaseNodeModelData {
  declare type: NodeTypes.Delay
  @Type(() => BaseDelayType, {
    keepDiscriminatorProperty: true,
    discriminator: {
      property: 'type',
      subTypes: [
        { name: DelayType.Interval, value: DelayIntervalType },
        { name: DelayType.Date, value: DelayDateType },
        { name: DelayType.Property, value: DelayPropertyType },
      ]
    }
  })
  delay!: BaseDelayType
}
